import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PropertiesSettings } from "../../../core/configuration/properties-settings";
import { HelpersService } from '../../../core/services/helpers.service';
import { OperationsService } from '../../../core/services/operations.service';
import {
  CalcoloInteressiRequestAdapter
} from '../../components/fascicolo/sezione-economica-data-interessi-edit/calcolo-interessi-adapter';
import { CalcoloInteressiRequest } from '../../models/calcolo-interessi-request';
import { Petitum } from '../../models/petitum';
import { BaseForm } from '../base-Form';

@Component({
    selector: 'div [valore-economico-data-interessi-form]',
  templateUrl: 'valore-economico-data-interessi-form.component.html'
})

export abstract class ValoreEconomicoDataInteressiFormComponent extends BaseForm {
  request: CalcoloInteressiRequest;
  calcoloInteressiForm: FormGroup;
  dataInizioCalcoloNumber: number;
  dataFineCalcoloNumber: number;

  tipoData: string;

  isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();
  abstract getPetitum(): Petitum;
  abstract getRequest(request);

  constructor(protected operationService: OperationsService,
              protected campiForm: FormBuilder,
              protected helpers: HelpersService) {
    super();
  }

  initRequest() {
    this.request = new CalcoloInteressiRequestAdapter(new CalcoloInteressiRequest()).calcoloInteressiRequest;
    this.dataInizioCalcoloNumber = this.getDataInizioCalcoloNumber();
    this.dataFineCalcoloNumber = (new Date()).valueOf();
    this.request.valore = this.getPetitum().importoPetitum;
  }

  getDataInizioCalcoloNumber(): number{
    let data = 0;
    switch(this.tipoData){
      case 'sorte':
        data = this.getPetitum().dataInizioCalcoloInteressi;
        break;
      case 'speselegali':
        data = this.getPetitum().dataInizioCalcoloInteressiSpeseLegali;
        break;
      case 'danno':
        data = this.getPetitum().dataInizioCalcoloInteressiMaggiorDanno;
        break;
      case 'rivalutazione':
        data = this.getPetitum().dataInizioCalcoloInteressiRivalutazione;
        break;
      default: break;
    }
    return data;
  }

  getLabel():string {
    let label = '';
    switch(this.tipoData){
      case 'sorte':
        label = 'Data inizio calcolo interessi';
        break;
      case 'speselegali':
        label = 'Data inizio calcolo interessi spese legali';
        break;
      case 'danno':
        label = 'Data inizio calcolo maggior danno';
        break;
      case 'rivalutazione':
        label = 'Data inizio calcolo rivalutazione';
        break;
      default: break;
    }
    return label;
  }

  createForm() {
      this.initRequest();
      this.calcoloInteressiForm = this.campiForm.group({
      dataInizioCalcolo: [this.dataInizioCalcoloNumber],
      dataFineCalcolo: [this.dataFineCalcoloNumber]
    });
  }

  populateSelect() {}

  save() {
    // this.getRequest(this.convertDateToString(this.dataInizioCalcoloNumber));
    this.getRequest(this.dataInizioCalcoloNumber);
  }

  convertDateToString(epochDate: number) { // yyyy-mm-dd
    let date = new Date(epochDate);
    let mm = date.getMonth() + 1; // getMonth() is zero-based
    let dd = date.getDate();
    return [date.getFullYear(), (mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd].join('-');
  };
}
